import { ProductsProvider } from 'application/contexts/products'
import store from 'application/store'
import GlobalStyle from 'global-styles/global-styles'
import { loadConfig } from 'infra/adapters/http-client-adapter'
import { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import { Router } from 'routes/router'

export const App = () => {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initializeApp = async () => {
      try {
        const config = await loadConfig()
        console.log('Configuração carregada:', config)
      } catch (error) {
        console.error('Erro ao inicializar a aplicação:', error)
      } finally {
        setLoading(false)
      }
    }

    initializeApp()
  }, [])

  if (loading) return null

  return (
    <Provider store={store}>
      <ProductsProvider>
        <ToastContainer autoClose={5000} />
        <GlobalStyle />
        <Router />
      </ProductsProvider>
    </Provider>
  )
}
